module.exports = __webpack_public_path__ + "static/img/um-movingAhead.a639e41a.png";